import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInfo } from '../../types/auth';
import './UserInfoModal.css';

interface UserInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: UserInfo | null;
}

const UserInfoModal: React.FC<UserInfoModalProps> = ({ isOpen, onClose, user }) => {
  const navigate = useNavigate();

  if (!isOpen || !user) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleChangePassword = () => {
    onClose();
    navigate('/profile/change-password');
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>Informazioni Utente</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <div className="user-info-grid">
            <div className="user-info-row">
              <div className="info-field">
                <label>Nome</label>
                <span>{user.nome || 'Non specificato'}</span>
              </div>
              <div className="info-field">
                <label>Cognome</label>
                <span>{user.cognome || 'Non specificato'}</span>
              </div>
            </div>
            
            <div className="user-info-row">
              <div className="info-field">
                <label>Email</label>
                <span>{user.email}</span>
              </div>
              <div className="info-field">
                <label>Ruolo</label>
                <span>{user.ruoli.join(', ')}</span>
              </div>
              <div className="info-field">
                <label>Stato</label>
                <span className="status active">Attivo</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="modal-footer">
          <button 
            className="btn btn-primary change-password-btn"
            onClick={handleChangePassword}
          >
            🔑 Cambia Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserInfoModal;